// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__a6UUH","footer":"ChangeClinic_footer__3SxvU"};